import { observer } from "mobx-react-lite";
import { useStore } from "../../app/stores/store";
import Breadcrumbs from "../common/breadcrumbs";
import React from "react";
import ReportFilter from "./ReportFilter";
import { ClientRequest } from "http";
import Header from "../common/header";
import ReportList from "./ReportList";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../router/all_routes";

const ReportDashboard = () => {
  const reportCards = [
    {
      title: "Category Sales Report",
      icon: "/assets/img/icons/details-icon.svg", // update with your icon path
      path: all_routes.customerReport,
    },
    {
      title: "Customer Report",
      icon: "/assets/img/icons/booking-icon.svg", // update with your icon path
      path: all_routes.customerReport,
    },
    {
      title: "Airport Report",
      icon: "/assets/img/icons/details-icon.svg", // update with your icon path
      path: all_routes.airportReport,
    },
  ];

  const {
    bookingStore: { pagination },
  } = useStore();
  const navigate = useNavigate();

  return (
    <>
      {/* Dashboard Header and Filters */}
      <div className="bg-gray-100 min-h-screen pt-20 pb-8">
        <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">Reports</h1>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {reportCards.map((report, idx) => (
                <div
                  key={idx}
                  onClick={() => navigate(report.path)}
                  className="cursor-pointer bg-white hover:shadow-md transition-all shadow p-5 rounded-xl flex items-center space-x-4"
                >
                  <div className="w-16 h-16 bg-gray-100 flex items-center justify-center rounded-full">
                    <img
                      src={report.icon}
                      alt={report.title}
                      className="h-8 w-8"
                    />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800">
                      {report.title}
                    </h3>
                    <p className="text-sm text-gray-500">
                      View detailed report
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default observer(ReportDashboard);
